/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { PriorLearningWorkflow } from 'common-typescript/types';
import { STUDENT_WORKFLOW_TYPE } from '../../../model/student-workflow-constants';

@Component({
    selector: 'sis-prior-learning-workflow-summary',
    templateUrl: './prior-learning-workflow-summary.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PriorLearningWorkflowSummaryComponent {
    readonly studentApplicationType = STUDENT_WORKFLOW_TYPE;

    @Input() workflow: PriorLearningWorkflow;
    @Output() openCourseUnitInfoModal = new EventEmitter();
}
